import React from "react";
import PropTypes from "prop-types";

const TaskProperties = ({ show, children }) => {
  if (!show) return null;
  return <>{children}</>;
};

TaskProperties.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node,
};
TaskProperties.defaultProps = {
  show: false,
};

export default TaskProperties;
